<template>
  <h2 class="titleStepForm">
    Appointment of Nominee <sup>(Beneficiary)</sup>
  </h2>
  <div class="">
    <p>
      <template v-if="isPdf">
      In the event of my death I, <strong> </strong> hereby
      </template>
      <template v-if="!isPdf">
      In the event of my death I,
      <strong>{{ form.personal.appliname }} </strong> hereby
      </template>
      nominate the following person(s) to receive any monies
      accruing to me in the Society:
    </p>
    <div class="groupFeildsNom border-bottom pb-3 mb-3">
      <div class="row">
        <div class="col-lg-4 mb-3">
          <label class="font-size-14"> Name</label>
          <input
            type="text"
            v-model="form.personal.appointnominee_name1"
            class="form-control"
            placeholder="Name"
            :class="{
              'is-invalid':
                v$.form.personal.appointnominee_name1.$error,
            }"
            disabled
          />
          <div
            v-for="(personal, index) in v$.form.personal
              .appointnominee_name1.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
        <div class="col-lg-8 mb-3">
          <label class="font-size-14"> Email Address</label>
          <input
            type="email"
            v-model="form.personal.appointnominee_email1"
            maxlength="100"
            class="form-control"
            placeholder="Email address"
            :class="{
              'is-invalid':
                v$.form.personal.appointnominee_email1.$error,
            }"
            disabled
          />

          <div
            v-for="(personal, index) in v$.form.personal
              .appointnominee_email1.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
        <div class="col-lg-4 mb-3">
          <label class="font-size-14"> Date of Birth</label>
          <AppDatePicker v-model="form.personal.appointnominee_dob1" placeholder="Select date of birth" past-only :invalid="v$.form.personal.appointnominee_dob1.$error" disabled />
          <div
            v-for="(personal, index) in v$.form.personal
              .appointnominee_dob1.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
        <div class="col-lg-4 mb-3">
          <template v-if="isPdf">
          <label class="font-size-14"> Phone Number</label>
          <input
            type="number"
            v-model="form.personal.appointnominee_pno1"
            maxlength="10"
            class="form-control"
            placeholder="Phone Number"
            :class="{
              'is-invalid':
                v$.form.personal.appointnominee_pno1.$error,
            }"
            disabled
          />
          </template>
          <template v-if="!isPdf">
          <label class="font-size-14">Phone Number</label>
          <div class="row">
            <div class="col-4 pe-0">
              <div class="single-select2-cstm">
                <Select2
                  disabled
                  v-model="
                    form.personal.appointnominee_pno1code
                  "
                  :options="countrynameIssuanceOpt"
                >
                </Select2>
              </div>
            </div>
            <div class="col-8 ps-0">
              <input
                type="number"
                v-model="form.personal.appointnominee_pno1"
                maxlength="10"
                class="form-control"
                placeholder="Phone Number"
                :class="{
                  'is-invalid':
                    v$.form.personal.appointnominee_pno1
                      .$error,
                }"
                disabled
              />
            </div>
          </div>
          </template>
          <div
            v-for="(personal, index) in v$.form.personal
              .appointnominee_pno1.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>

        <template v-if="isPdf">
        <div class="col-lg-4 mb-3">
          <label class="font-size-14"> Rel. to Member</label>
          <input
            type="tel"
            v-model="form.personal.appointnominee_rel1"
            maxlength="10"
            class="form-control"
            placeholder="Relation to Member"
            :class="{
              'is-invalid':
                v$.form.personal.appointnominee_rel1.$error,
            }"
            disabled
          />
          <div
            v-for="(personal, index) in v$.form.personal
              .appointnominee_rel1.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
        </template>
        <template v-if="!isPdf">
        <div class="col-lg-4 mb-3">
          <label class="font-size-14"> Rel. to Member</label>
          <input
            type="tel"
            v-model="form.personal.appointnominee_rel1"
            maxlength="10"
            class="form-control"
            placeholder="Relation to Member"
            :class="{
              'is-invalid':
                v$.form.personal.appointnominee_rel1.$error,
            }"
            disabled
          />
          <div
            v-for="(personal, index) in v$.form.personal
              .appointnominee_rel1.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
        <div
          class="col-lg-4 mb-3"
          v-if="
            form.personal.appointnominee_rel1 ===
            'Other family member'
          "
        >
          <label class="font-size-14">
            Specify The Relation</label
          >
          <input
            type="textarea"
            v-model="form.personal.appointnominee_rel_details"
            class="form-control"
            disabled
          />
        </div>
        </template>
        <div class="col-lg-12 mb-3">
          <label class="font-size-14"> Address</label>
          <input
            type="tel"
            v-model="form.personal.appointnominee_address1"
            maxlength="10"
            class="form-control"
            placeholder="Relation to Member"
            :class="{
              'is-invalid':
                v$.form.personal.appointnominee_address1
                  .$error,
            }"
            disabled
          />
          <div
            v-for="(personal, index) in v$.form.personal
              .appointnominee_address1.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
        <!-- Optional validation: appointnominee_gcode1 -->
      </div>
    </div>
    <div class="groupFeildsNom border-bottom pb-3 mb-3">
      <div class="row">
        <div class="col-lg-4 mb-3">
          <label class="font-size-14"> Name </label>
          <input
            type="text"
            v-model="form.personal.appointnominee_name2"
            class="form-control"
            placeholder="Name"
            :class="{
              'is-invalid':
                v$.form.personal.appointnominee_name2.$error,
            }"
            disabled
          />
          <div
            v-for="(personal, index) in v$.form.personal
              .appointnominee_name2.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
        <div class="col-lg-8 mb-3">
          <label class="font-size-14"> Email Address</label>
          <input
            type="email"
            v-model="form.personal.appointnominee_email2"
            maxlength="100"
            class="form-control"
            placeholder="Email address"
            :class="{
              'is-invalid':
                v$.form.personal.appointnominee_email2.$error,
            }"
            disabled
          />

          <div
            v-for="(personal, index) in v$.form.personal
              .appointnominee_email2.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
        <div class="col-lg-4 mb-3">
          <label class="font-size-14"> Date of Birth</label>
          <AppDatePicker v-model="form.personal.appointnominee_dob2" placeholder="Select date of birth" past-only :invalid="v$.form.personal.appointnominee_dob2.$error" disabled />

          <div
            v-for="(personal, index) in v$.form.personal
              .appointnominee_dob2.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
        <div class="col-lg-4 mb-3">
          <label class="font-size-14"> Phone Number</label>
          <template v-if="isPdf">
          <input
            type="number"
            v-model="form.personal.appointnominee_pno2"
            maxlength="10"
            class="form-control"
            placeholder="Phone Number"
            :class="{
              'is-invalid':
                v$.form.personal.appointnominee_pno2.$error,
            }"
            disabled
          />
          </template>
          <template v-if="!isPdf">
          <div class="row">
            <div class="col-4 pe-0">
              <div class="single-select2-cstm">
                <Select2
                  disabled
                  v-model="
                    form.personal.appointnominee_pno1code2
                  "
                  :options="countrynameIssuanceOpt"
                >
                </Select2>
              </div>
            </div>
            <div class="col-8 ps-0">
              <input
                type="number"
                v-model="form.personal.appointnominee_pno2"
                maxlength="10"
                class="form-control"
                placeholder="Phone Number"
                :class="{
                  'is-invalid':
                    v$.form.personal.appointnominee_pno2
                      .$error,
                }"
                disabled
              />
            </div>
          </div>

          </template>
          <div
            v-for="(personal, index) in v$.form.personal
              .appointnominee_pno2.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
        <template v-if="isPdf">
        <div class="col-lg-4 mb-3">
          <label class="font-size-14"> Rel. to Member</label>
          <input
            type="tel"
            v-model="form.personal.appointnominee_rel2"
            maxlength="10"
            class="form-control"
            placeholder="Relation to Member"
            :class="{
              'is-invalid':
                v$.form.personal.appointnominee_rel2.$error,
            }"
            disabled
          />
          <div
            v-for="(personal, index) in v$.form.personal
              .appointnominee_rel2.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
        </template>
        <template v-if="!isPdf">
        <div class="col-lg-4 mb-3">
          <label class="font-size-14"> Rel. to Member</label>
          <input
            type="tel"
            v-model="form.personal.appointnominee_rel2"
            maxlength="10"
            class="form-control"
            placeholder="Relation to Member"
            :class="{
              'is-invalid':
                v$.form.personal.appointnominee_rel2.$error,
            }"
            disabled
          />
          <div
            v-for="(personal, index) in v$.form.personal
              .appointnominee_rel2.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
        <div
          class="col-lg-4 mb-3"
          v-if="
            form.personal.appointnominee_rel2 ===
            'Other family member'
          "
        >
          <label class="font-size-14">
            Specify The Relation</label
          >
          <input
            type="textarea"
            v-model="
              form.personal.appointnominee_rel2_details
            "
            class="form-control"
            disabled
          />
        </div>
        </template>

        <div class="col-lg-12 mb-3">
          <label class="font-size-14"> Address</label>
          <input
            type="tel"
            v-model="form.personal.appointnominee_address2"
            maxlength="10"
            class="form-control"
            placeholder="Relation to Member"
            :class="{
              'is-invalid':
                v$.form.personal.appointnominee_address2
                  .$error,
            }"
            disabled
          />
          <div
            v-for="(personal, index) in v$.form.personal
              .appointnominee_address2.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
        <!-- Optional validation: appointnominee_gcode2 -->
      </div>
    </div>
    <div class="">
      <p>
        I reserve the right to change or terminate the
        designated beneficiary/ies at any time. I further
        agree that any designation, termination or change of
        beneficiary shall be binding upon the Credit Union
        only if filed with the Credit Union prior to my death.
        In accordance with the Co-operative Societies Act Chap
        81:03 , as outlined in
        <strong>ECU’s Bye Laws #10,</strong> a duly named
        nominee of a deceased member of the Society is
        <template v-if="isPdf">
        entitled to the sum not exceeding five thousand
        dollars ($5,000.00) of the unencumbered money due to
        </template>
        <template v-if="!isPdf">
        entitled to the sum not exceeding fifty thousand
        dollars ($50,000.00) of the unencumbered money due to
        </template>
        the death of the said member of the Society. All other
        monies due to the deceased member shall fall into his
        estate and be subject in all respects to the laws
        relating to inheritance including the requirement to
        pay estate duty.
      </p>
      <!-- Optional validation: hereRadio1 -->
      <div
        class="minorDivShow"
        v-if="radioSelected1 === 'minor'"
      >
        <h6 class="font-size-15">
          Complete this Section only if Nominee is a minor
        </h6>
        <label
          for="hereByRd"
          class="w-100 b-0 p-relative labelStyleRadioCstm pt-0 pb-0"
          :class="{
            'is-invalid': v$.form.personal.hereRadio1.$error,
          }"
        >
          <input
            type="checkbox"
            :checked="
              radioSelected1 === 'minor' ? 'true' : 'false'
            "
            v-model="form.personal.hereRadio1"
            class="inputRadioCstm d-none"
            id="hereByRd"
            value="True"
            disabled
          />
          <span class="radioCircleIcon line-height-1">
            <i
              class="mdi mdi-checkbox-blank-outline text-theme font-size-22"
            ></i>
            <i
              class="mdi mdi-check-box-outline text-theme theme-check font-size-22"
            ></i>
          </span>
          <h4
            class="font-size-13 line-height-17 text-dark-custom font-weight-400 mb-0 ms-1"
          >
            I hereby nominate the following person/company to
            act as; Trustee/Guardian on behalf of my nominee
            should my nominee still be a minor (under age 18)
            upon my death.
          </h4>
        </label>
        <div
          v-for="(personal, index) in v$.form.personal
            .hereRadio1.$errors"
          :key="index"
          class="invalid-feedback"
        >
          <span v-if="personal.$message">{{
            personal.$message
          }}</span>
        </div>
        <div class="row align-items-center">
          <div class="col-lg-4 mb-3">
            <div class="row gx-2">
              <div class="col-auto">
                <label
                  for="trusteeRd"
                  class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                  :class="{
                    'is-invalid':
                      v$.form.personal.trusteeRadioo.$error,
                  }"
                >
                  <input
                    type="radio"
                    v-model="form.personal.trusteeRadioo"
                    value="trustee"
                    class="inputRadioCstm d-none"
                    id="trusteeRd"
                  />
                  <span class="radioCircleIcon">
                    <i
                      class="mdi mdi-circle-outline text-theme font-size-20"
                    ></i>
                    <i
                      class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                    ></i>
                  </span>
                  <h4
                    class="font-size-14 text-dark-custom mb-0 ms-1"
                  >
                    Trustee
                  </h4>
                </label>
                <div
                  v-for="(personal, index) in v$.form.personal
                    .trusteeRadioo.$errors"
                  :key="index"
                  class="invalid-feedback"
                >
                  <span v-if="personal.$message">{{
                    personal.$message
                  }}</span>
                </div>
              </div>
              <div class="col-auto">
                <label
                  for="guardianRd"
                  class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                  :class="{
                    'is-invalid':
                      v$.form.personal.trusteeRadioo.$error,
                  }"
                >
                  <input
                    type="radio"
                    v-model="form.personal.trusteeRadioo"
                    value="guardian"
                    class="inputRadioCstm d-none"
                    id="guardianRd"
                  />
                  <span class="radioCircleIcon">
                    <i
                      class="mdi mdi-circle-outline text-theme font-size-20"
                    ></i>
                    <i
                      class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                    ></i>
                  </span>
                  <h4
                    class="font-size-14 text-dark-custom mb-0 ms-1"
                  >
                    Guardian
                  </h4>
                </label>
                <div
                  v-for="(personal, index) in v$.form.personal
                    .trusteeRadioo.$errors"
                  :key="index"
                  class="invalid-feedback"
                >
                  <span v-if="personal.$message">{{
                    personal.$message
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-8 mb-3">
            <div class="d-block">
              <label class="font-size-14"
                >Relationship to Beneficiary</label
              >
              <input
                type="text"
                v-model="form.personal.relationbenifit3"
                class="form-control"
                placeholder="Relationship to Beneficiary"
                :class="{
                  'is-invalid':
                    v$.form.personal.relationbenifit3.$error,
                }"
                disabled
              />
              <div
                v-for="(personal, index) in v$.form.personal
                  .relationbenifit3.$errors"
                :key="index"
                class="invalid-feedback"
              >
                <span v-if="personal.$message">{{
                  personal.$message
                }}</span>
              </div>
            </div>
          </div>
          <template v-if="!isPdf">
          <div
            class="col-lg-4 mb-3"
            v-if="
              form.personal.relationbenifit3 ===
              'Other family member'
            "
          >
            <label class="font-size-14">
              Specify The Relation</label
            >
            <input
              type="textarea"
              v-model="
                form.personal.relationbenifit3_relation
              "
              class="form-control"
              disabled
            />
          </div>
          </template>
        </div>
        <div class="groupFeildsNom border-top pt-3 mt-3">
          <div class="row">
            <div class="col-lg-4 mb-3">
              <label class="font-size-14"> Name</label>
              <input
                type="text"
                v-model="form.personal.appointnominee_name3"
                class="form-control"
                placeholder="Name"
                :class="{
                  'is-invalid':
                    v$.form.personal.appointnominee_name3
                      .$error,
                }"
                disabled
              />
              <div
                v-for="(personal, index) in v$.form.personal
                  .appointnominee_name3.$errors"
                :key="index"
                class="invalid-feedback"
              >
                <span v-if="personal.$message">{{
                  personal.$message
                }}</span>
              </div>
            </div>
            <template v-if="isPdf">
            <div class="col-lg-8 mb-3">
              <label class="font-size-14">
                Email Address</label
              >
              <input
                type="email"
                v-model="form.personal.appointnominee_email3"
                maxlength="100"
                class="form-control"
                placeholder="Email address"
                :class="{
                  'is-invalid':
                    v$.form.personal.appointnominee_email3
                      .$error,
                }"
                disabled
              />

              <div
                v-for="(personal, index) in v$.form.personal
                  .appointnominee_email3.$errors"
                :key="index"
                class="invalid-feedback"
              >
                <span v-if="personal.$message">{{
                  personal.$message
                }}</span>
              </div>
            </div>
            </template>
            <template v-if="!isPdf">
            <div class="col-lg-4 mb-3">
              <label class="font-size-14">
                Email Address</label
              >
              <input
                type="email"
                v-model="form.personal.appointnominee_email3"
                maxlength="100"
                class="form-control"
                placeholder="Email address"
                :class="{
                  'is-invalid':
                    v$.form.personal.appointnominee_email3
                      .$error,
                }"
                disabled
              />

              <div
                v-for="(personal, index) in v$.form.personal
                  .appointnominee_email3.$errors"
                :key="index"
                class="invalid-feedback"
              >
                <span v-if="personal.$message">{{
                  personal.$message
                }}</span>
              </div>
            </div>
            </template>
            <div class="col-lg-4 mb-3">
              <label class="font-size-14">
                Date of Birth</label
              >
              <AppDatePicker v-model="form.personal.appointnominee_dob3" placeholder="Select date of birth" past-only :invalid="v$.form.personal.appointnominee_dob3 .$error" disabled />

              <div
                v-for="(personal, index) in v$.form.personal
                  .appointnominee_dob3.$errors"
                :key="index"
                class="invalid-feedback"
              >
                <span v-if="personal.$message">{{
                  personal.$message
                }}</span>
              </div>
            </div>
            <div class="col-lg-4 mb-3">
              <template v-if="isPdf">
              <label class="font-size-14">
                Phone Number</label
              >
              <input
                type="number"
                v-model="form.personal.appointnominee_pno3"
                maxlength="10"
                class="form-control"
                placeholder="Phone Number"
                :class="{
                  'is-invalid':
                    v$.form.personal.appointnominee_pno3
                      .$error,
                }"
                disabled
              />
              <div
                v-for="(personal, index) in v$.form.personal
                  .appointnominee_pno3.$errors"
                :key="index"
                class="invalid-feedback"
              >
                <span v-if="personal.$message">{{
                  personal.$message
                }}</span>
              </div>
              </template>
              <template v-if="!isPdf">
              <label class="font-size-14">Phone Number</label>
              <div class="row">
                <div class="col-4 pe-0">
                  <div class="single-select2-cstm">
                    <Select2
                      disabled
                      v-model="
                        form.personal.appointnominee_pno1code3
                      "
                      :options="countrynameIssuanceOpt"
                    >
                    </Select2>
                  </div>
                </div>
                <div class="col-8 ps-0">
                  <input
                    type="number"
                    v-model="
                      form.personal.appointnominee_pno3
                    "
                    maxlength="10"
                    class="form-control"
                    placeholder="Phone Number"
                    :class="{
                      'is-invalid':
                        v$.form.personal.appointnominee_pno3
                          .$error,
                    }"
                    disabled
                  />
                </div>
                <div
                  v-for="(personal, index) in v$.form.personal
                    .appointnominee_pno3.$errors"
                  :key="index"
                  class="invalid-feedback"
                >
                  <span v-if="personal.$message">{{
                    personal.$message
                  }}</span>
                </div>
              </div>
              </template>
            </div>
            <template v-if="!isPdf">
            <!-- Optional validation: appointnominee_pno2 -->
            </template>
            <!-- Optional validation: appointnominee_g_code3 -->
            <template v-if="isPdf">
            <div class="col-lg-12 mb-3">
              <label class="font-size-14"> Address</label>
              <input
                type="tel"
                v-model="
                  form.personal.appointnominee_address3
                "
                maxlength="10"
                class="form-control"
                placeholder="Address"
                :class="{
                  'is-invalid':
                    v$.form.personal.appointnominee_address3
                      .$error,
                }"
                disabled
              />
              <div
                v-for="(personal, index) in v$.form.personal
                  .appointnominee_address3.$errors"
                :key="index"
                class="invalid-feedback"
              >
                <span v-if="personal.$message">{{
                  personal.$message
                }}</span>
              </div>
            </div>
            </template>
            <template v-if="!isPdf">
            <div class="col-lg-8 mb-3">
              <label class="font-size-14"> Address</label>
              <input
                type="tel"
                v-model="
                  form.personal.appointnominee_address3
                "
                maxlength="10"
                class="form-control"
                placeholder="Address"
                :class="{
                  'is-invalid':
                    v$.form.personal.appointnominee_address3
                      .$error,
                }"
                disabled
              />
              <div
                v-for="(personal, index) in v$.form.personal
                  .appointnominee_address3.$errors"
                :key="index"
                class="invalid-feedback"
              >
                <span v-if="personal.$message">{{
                  personal.$message
                }}</span>
              </div>
            </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from "vue3-select2-component";
import { bridge } from "../formBridge";
import AppDatePicker from "@/components/shared/AppDatePicker.vue";

export default {
  name: "ReviewNominee",
  props: {
    variant: { type: String, default: "review" },
  },
  computed: {
    isPdf() {
      return this.variant === "pdf";
    },
  },
  mixins: [
    bridge({
    state: ["radioSelected1", "countrynameIssuanceOpt", "form"],
    validate: true,
    }),
  ],
  components: { Select2, AppDatePicker },
};
</script>